import axios from 'axios';
import * as THREE from "three";
import React, { useEffect } from 'react';
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import Input from '@material-ui/core/Input';
import InputAdornment from '@material-ui/core/InputAdornment';
import FormControl from '@material-ui/core/FormControl';
import Typography from '@material-ui/core/Typography'
import TextField from '@material-ui/core/TextField';
import Select from "@material-ui/core/Select";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import { makeStyles } from '@material-ui/core/styles'
import SideStyle from '../style/sideStyle';
import Control from '../store/control';
import Param from '../store/param';
import { AddIcon } from './formUtil';
// import { Start, Check, GetSTL, GetLog } from "../fileIO/post";
// import { POLLING_INTERVAL1 } from '../store/global';


const FormThick = () => {
  const style      = SideStyle();
  const thick      = Param.Get("thick");
  const setParam   = Param.Get("setParam");
  const setControl = Control.Get("setControl");
  const SetCameraFront = Control.Get("SetCameraFront");
  const SetCameraFree = Control.Get('SetCameraFree')
  const meshSocketTrimVtk = Control.Get("meshSocketTrimVtk");

  const useStyles = makeStyles({
    whiteText: {
      color: 'white',
    },
  });

  const classes = useStyles();

  const onThick = () => {
    if (process.env.REACT_APP_CALC_MODE == 0) {
      console.log("onThick local");
      setParam(s => {s.thick.step = 1});
      
    } else if (process.env.REACT_APP_CALC_MODE == 1) {

      console.log("onThick server");
    
      // axios settings
      const url  = process.env.REACT_APP_BACKEND_SERVER + '/api/thick';
      const data = {
        'socketVertices': meshSocketTrimVtk.vertices,
        'socketFaces': meshSocketTrimVtk.faces,
        'smooth': Number(thick.smooth),
        'outerThickness': Number(thick.outerThickness),
      };
      const header = {
        headers: {
          'Content-Type': 'application/json',
        }
      };

      axios.post(url, data, header)
      //axios.get(url)
      .then(res => {
        console.log('get data from server to client');

        // socket mesh surface
        if (true) {
          const socketVertices = res.data['socketVertices'];
          const socketFaces = res.data['socketFaces'];

          var vertices = [];
          var faces = [];
          var face = [];
          var nFace = [];
          var temp = [];

          // convert to numpy array to three array
          for (var i = 0; i < socketVertices.length; i++) {
            var p = new THREE.Vector3(...socketVertices[i]);
            vertices.push(p);
          }

          console.log(socketFaces.length)
          // convert to numpy array to three array
          for (var i = 0; i < socketFaces.length; i++) {
            nFace = socketFaces[i];
            face = socketFaces.slice(i+1, i+nFace+1);

            if (nFace==3) {
              //faces.push(new THREE.Face3(...face)); // this is for geometry format, but departed and not working well
              faces.push(...face) // this is for buffergeometry
            } else if (nFace==4) { // devide quad mesh into two triangle mesh
              temp = [face[0], face[1], face[2]];
              //faces.push(new THREE.Face3(...temp)) // this is for geometry
              faces.push(...temp) // this is for buffergeometry
              temp = [face[0], face[2], face[3]];
              //faces.push(new THREE.Face3(...temp)) // this is for geometry
              faces.push(...temp) // // this is for buffergeometry
            }
            i += nFace;
          }

          var temp = {
            vertices: res.data['socketVertices'],
            faces: res.data['socketFaces'],
          };
          console.log(temp)
          setControl(s => {s.meshSocketThickVtk = temp});

          temp = {
            vertices: vertices,
            faces: faces,
          };
          console.log(temp)
          setControl(s => {s.meshSocketThick = temp});

          setParam(s => {s.thick.step = 1});
        }
      })
    }
    //.catch(err => {
    //  console.log('error');
    //});
  }

  const onClear = () => {
    setControl(s => {s.meshSocketThick = null});
    setControl(s => {s.meshSocketThickVtk = null});
    setParam(s => {s.thick.step = 0});
  };

  const handleValue = (e) => {
    setParam(s => {s.thick[e.target.name] = Number(e.target.value)});
  };

  useEffect(() => {
  //   setControl(s => {s.flgLegClickable = false, s.flgSocketClickable = false});
    setParam(s => {s.instructionText = "Confirm the created socket, and go to [JOINT]"});
    //SetCameraFront()
    SetCameraFree()
  }, []);


  return (
    <div className={style.outside}>
      <Grid container direction='column' justifyContent ='flex-start' alignItems='center'>

        {/* Thickness */}
        <Grid item xs={12} className={style.subcategory}>Thickness</Grid>
        <Grid container spacing={1} alignItems='center'>
          <TextField
            id="filled-number"
            name='outerThickness'
            label="Outer thickness"
            type="number"
            defaultValue={thick.outerThickness}
            fullWidth
            onBlur={handleValue}
            InputProps={{
              endAdornment: <AddIcon unit="mm" helptext="Add thickness to outside from base surface"/>,
            }}
            InputLabelProps={{
              style: { color: '#fff' },
              shrink: true,
            }}
            variant="standard"
            inputProps={{
              style: {
                color: "white",
                textAlign: "left"
              }, 
              min:0, 
              max:10,
              step:1
            }}
          />

          <TextField
            id='filled-number'
            name='boundaryCurveIndex'
            label='Boundary curve index for smoothing'
            type='number'
            defaultValue={thick.boundaryCurveIndex+1}
            fullWidth
            onBlur={handleValue}
            InputProps={{
              endAdornment: <AddIcon unit='' helptext='Boundary curve index for smoothing'/>,
            }}
            InputLabelProps={{
              style: { color: '#fff' },
              shrink: true,
            }}
            variant='standard'
            inputProps={{
              style: {
                color: 'white',
                textAlign: 'left'
              }, 
              min:1,
              max:thick.maxBoundaryCurveIndex+1,
              step:1
            }}
          />

          <TextField
            id="filled-number"
            name='flexionAngle'
            label="Flexion angle"
            type="number"
            defaultValue={thick.flexionAngle}
            fullWidth
            onBlur={handleValue}
            InputProps={{
              endAdornment: <AddIcon unit="°" helptext="Flxion angle"/>,
            }}
            InputLabelProps={{
              style: { color: '#fff' },
              shrink: true,
            }}
            variant="standard"
            inputProps={{
              style: {
                color: "white",
                textAlign: "left"
              }, 
              min:0, 
              max:180,
              step:1
            }}
          />
        </Grid>

        <FormControl fullWidth>
          <InputLabel>Connector type</InputLabel>
          <Select
            type='number'
            name='connector'
            defaultValue={thick.connector}
            value={thick.connector}
            onChange={handleValue}
            className={classes.whiteText}
          >
            <MenuItem value={0}>Cube</MenuItem>
            {/* <MenuItem value={1}>Two hole</MenuItem> */}
            <MenuItem value={2}>Four hole</MenuItem>
          </Select>
        </FormControl>


        <Grid container spacing={1} alignItems='center'>
          <TextField
            id="filled-number"
            name='apConnector'
            label="Connector +Front/-Back"
            type="number"
            defaultValue={thick.apConnector}
            fullWidth
            onBlur={handleValue}
            InputProps={{
              endAdornment: <AddIcon unit="mm" helptext=""/>,
            }}
            InputLabelProps={{
              style: { color: '#fff' },
              shrink: true,
            }}
            variant="standard"
            inputProps={{
              style: {
                color: "white",
                textAlign: "left"
              }, 
              min:-50, 
              max:50,
              step:1
            }}
          />

          <TextField
            id="filled-number"
            name='mlConnector'
            label="Connector +Medial/-Lateral"
            type="number"
            defaultValue={thick.mlConnector}
            fullWidth
            onBlur={handleValue}
            InputProps={{
              endAdornment: <AddIcon unit="mm" helptext=""/>,
            }}
            InputLabelProps={{
              style: { color: '#fff' },
              shrink: true,
            }}
            variant="standard"
            inputProps={{
              style: {
                color: "white",
                textAlign: "left"
              }, 
              min:-50, 
              max:50,
              step:1
            }}
          />
        </Grid>

        

        <Grid container spacing={5} alignItems='center'>
          <Grid item xs={6}>
            <Button className={(thick.step==1) ? style.buttonDisable : style.button} onClick={onThick} size="small" >Thicken</Button>
          </Grid>
          <Grid item xs={6}>
            <Button className={(thick.step==0) ? style.buttonDisable : style.button} onClick={onClear} disabled={(thick.step==0)} size="small" >Clear Socket</Button>
          </Grid>
        </Grid>

      </Grid>
    </div>
  );
}
export default FormThick;
